import React from "react"
import LeftMenu from "../componets/LeftMenu"
import "../styles/main.scss"

export default function Template({children,path}) {
  return (
    <div className="clearfix mainConatiner">
      <LeftMenu route={path}/>
      {children}
    </div>
  );
}
